var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-grid-size',{class:_vm.containerClass},[_c('v-row',[_c('v-col',{attrs:{"lg":_vm.width.lg,"offset-lg":_vm.width.offsetLg}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }